import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DataLayerEditModalContainer, type DataLayerEditModalProps,
} from './dataLayerEditModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DataLayerEdit: DataLayerEditModalProps;
  }
}

modalRenderer.register('DataLayerEdit', DataLayerEditModalContainer);
